
export default {
    "system.module": "系统模块",
    "system.module.admin": "后台系统",
    "system.module.blog": "个人博客",
    "system.module.website": "门户网站",
    "system.module.mobile": "手机端",
    "system.module.category": "资源分类",
    "admin.access.noright": "您没有访问权限请联系管理员。",
    "admin.back.home": "返回首页",
    "admin.login.title": "用户登录",
    "admin.login.username": "用户名",
    "admin.login.username.placeholder": "请输入用户名",
    "admin.login.password": "密码",
    "admin.login.password.placeholder": "请输入密码",
    "admin.login.verify": "验证码",
    "admin.login.verify.placeholder": "请输入验证码",
    "admin.login.button.submit": "登录",
    "admin.login.error.invalid": "登录用户名或密码错误。",
    "admin.login.error.invalid.Login_Invalid": "登录用户名或密码错误。",
    "admin.login.error.invalid.Login_Captcha": "验证码错误。",
    "admin.login.error.invalid.Login_500": "登录用户名或密码错误。",
    "admin.login.status.expired": "登录信息已过期或未登录，请重新登录系统。",
    "admin.registe.title": "新用户注册",
    "admin.layout.language.zhCN": "简体中文",
    "admin.layout.language.enGB": "English",
    "admin.layout.language": "多语言",
    "admin.layout.logout": "注销账户",
    "admin.layout.adgroup": "所属用户组",
    "admin.layout.logo.full": "后台管理系统",
    "admin.layout.logo.abbr": "ELM",
    "admin.layout.modal.confirm": "确定",
    "admin.layout.modal.cancel": "取消",
    "admin.layout.modal.question": "询问",
    "admin.layout.modal.logout": "确定退出当前账号?",
    "admin.layout.modal.delete.msg": "确定删除当前数据？",
    "admin.layout.modal.cancel.msg": "撤销发布以后需要再次提交审核才能发布，确定撤销？",
    "admin.layout.pleaseSelect": "请选择",
    "admin.layout.placeholder.search": "请输入搜索内容",
    "admin.layout.form.search.confirm": "搜索",
    "admin.layout.form.search.clear": "清空",
    "admin.layout.form.search.collapse": "更多",
    "admin.layout.theme": "主题",
    "admin.layout.theme.light": "亮色",
    "admin.layout.theme.dark": "暗黑",
    "admin.pages.form.submit": "提交",
    "admin.pages.form.submit.success": "数据提交成功！",
    "admin.pages.form.back": "返回",
    "admin.pages.form.reset": "重置",
    "admin.layout.copyright1": "版权所有",
    "admin.layout.copyright2": "。保留所有权利。",
    "admin.layout.input.placeholder": "请输入",
    "admin.layout.select.placeholder": "请选择",
    "admin.menu.main": "首页",
    "admin.menu.setting": "系统设置",
    "admin.menu.blog": "文章管理",
    "admin.pages.createUser": "创建用户",
    "admin.pages.createTime": "创建时间",
    "admin.pages.updateUser": "更新用户",
    "admin.pages.updateTime": "更新时间",
    "admin.pages.operate.delete":"删除",
    "admin.pages.operate.edit":"编辑",
    "admin.pages.operate.add":"添加",
    "admin.pages.operate.cancel": "撤销",
    "admin.pages.operate.disabled":"禁用",
    "admin.pages.operate.enabled":"启用",
    "admin.pages.operate.yes":"是",
    "admin.pages.operate.no":"否",
    "admin.pages.settings.profile": "高级设置",
    "admin.pages.settings.menus.general": "基本设置",
    "admin.pages.settings.menus.account": "账号设置",
    "admin.pages.settings.menus.group": "权限分组",
    "admin.pages.settings.website.sitename": "站点名称",
    "admin.pages.settings.website.description": "系统描述",
    "admin.pages.settings.website.adminSite.name.full": "后台系统名称",
    "admin.pages.settings.website.adminSite.name.abbr": "后台名称缩写",
    "admin.pages.settings.website.keywords": "关键词",
    "admin.pages.settings.website.contactor": "联系人",
    "admin.pages.settings.website.contactor.email": "联系人邮箱",
    "admin.pages.settings.website.copyright": "版权",
    "admin.pages.menus.edit.module.admin": "后台系统",
    "admin.pages.menus.edit.module.blog": "博客",
    "admin.pages.menus.edit.module.web": "门户网站",
    "admin.pages.menus.edit.module.wechat": "微信公众号",
    "admin.pages.menus.edit.module": "菜单模块",
    "admin.pages.menus.edit.parent": "父级菜单",
    "admin.pages.menus.edit.firstLevel": "顶级菜单",
    "admin.pages.menus.edit.title": "菜单名称",
    "admin.pages.menus.edit.icon": "图标",
    "admin.pages.menus.edit.pathname": "页面",
    "admin.pages.menus.edit.status": "状态",
    "admin.pages.menus.edit.status.enable": "启用",
    "admin.pages.menus.edit.status.disable": "禁用",
    "admin.pages.menus.edit.selectIcon": "选择图标",
    "admin.pages.menus.list.title": "系统菜单",
    "admin.pages.menus.list.id": "ID",
    "admin.pages.menus.list.name": "菜单标题",
    "admin.pages.menus.list.pathname": "页面路径",
    "admin.pages.menus.list.sort": "排序",
    "admin.pages.menus.add.title": "新增菜单",
    "admin.pages.menus.delete.msg": "确定删除当前菜单？",
    "admin.pages.languages.type": "语言",
    "admin.pages.languages.content": "内容",
    "admin.pages.languages.all": "全部",
    "admin.pages.language.name": "字段名称",
    "admin.pages.language.english": "英文",
    "admin.pages.language.chinese": "中文",
    "admin.pages.language.operate": "操作",
    "admin.pages.language.modal.add": "添加记录",
    "admin.pages.language.modal.edit": "编辑内容",
    "admin.pages.language.msg.delete": "注意：删除多语言设置后引用到的地方将会显示Key,重新添加即可。",
    "admin.pages.user.list.name": "登录名",
    "admin.pages.user.list.nickname": "昵称",
    "admin.pages.user.list.salt": "安全阀值",
    "admin.pages.user.list.smsNote": "短信备注",
    "admin.pages.user.list.status": "状态",
    "admin.pages.user.list.password.n": "新密码",
    "admin.pages.user.list.password.r": "重复密码",
    "admin.pages.user.list.msg.delete": "删除账号后再次添加出现Name已存在请联系管理处理，您确认删除当前用户账号？",
    "admin.pages.user.group.list.name": "权限组Key",
    "admin.pages.user.group.list.title": "权限组名称",
    "admin.pages.user.group.list.module": "授权模块",
    "admin.pages.user.group.list.user": "授权用户",
    "admin.pages.user.group.list.msg.delete": "确认删除当前选择的权限组？",
    "admin.pages.user.group.list.msg.sendsms": "确认发送短信通知？",
    "admin.pages.user.group.list.sendsms": "发送短信通知",
    "admin.pages.user.group.list.smsstatus": "最后发送短信状态",
    "admin.pages.user.group.list.smsnote": "最后发送短信备注",
    "admin.pages.user.group.list.template": "短信模板Id",
    "admin.pages.user.group.list.note": "备注",
    "admin.pages.user.group.edit.modules": "授权模块",
    "admin.pages.user.group.edit.user": "用户",
    "admin.pages.user.group.edit.auth": "已授权",
    "admin.pages.user.group.edit.item": "项",
    "admin.pages.user.group.edit.items": "项",
    "admin.pages.article.list.id": "内容ID",
    "admin.pages.article.title": "内容标题",
    "admin.pages.article.category": "内容分类",
    "admin.pages.article.typeTile": "内容类型",
    "admin.pages.article.edit.status.enable": "已发布",
    "admin.pages.article.edit.status.disable": "未发布",
    "admin.pages.article.edit.status.unapprove": "待审核",
    "admin.pages.article.allCategory": "全部分类",
    "admin.layout.article.title.list": "内容列表",
    "admin.layout.article.title.edit": "编辑内容",
    "admin.pages.article.header": "封面",
    "admin.pages.article.desc": "简介",
    "admin.pages.article.keywords": "关键字",
    "admin.pages.article.download": "开放下载",
    "admin.pages.article.visits": "访问量",
    "admin.pages.article.isOriginal": "是否原创",
    "admin.pages.article.content": "内容",
    "admin.pages.article.download.refused": "拒绝下载",
    "admin.pages.article.download.allow": "允许下载",
    "admin.pages.article.download.limit": "授权下载",
    "admin.pages.article.original.false": "非原创",
    "admin.pages.article.original.true": "原创",
    "admin.pages.article.formItem.required": "必填项不能为空",
    "admin.pages.menus.edit.isRef": "是否外链",
    "admin.pages.article.refUrl": "链接",
    "admin.pages.special.list.title": "专家列表",
    "admin.pages.special.edit.title": "专家信息",
    "admin.pages.special.category": "专家类型",
    "admin.pages.special.category.title": "编辑专家类型",
    "admin.pages.setting.options.name": "标识",
    "admin.pages.setting.options.value": "值",
    "admin.pages.special.goodat.title": "擅长领域",
    "admin.pages.special.goodat.edit.title": "编辑擅长领域",
    "admin.pages.law.list.title": "政策法规",
    "admin.pages.law.edit.title": "编辑内容",
    "admin.pages.law.category.title": "政策法规分类",
    "admin.pages.law.category.edit.title": "编辑法规分类",
    "admin.pages.activity.edit.title": "编辑活动信息",
    "admin.pages.activity.list.title": "活动列表",
    "admin.pages.activity.apply.list.title": "活动申报列表",
    "admin.pages.activity.apply.edit.title": "活动申报编辑",
    "admin.pages.activity.apply.detail.edit.title": "活动申报入库编辑",
    "admin.pages.carousel.list.title": "轮播图列表",
    "admin.pages.carousel.edit.title": "编辑轮播图",
    "admin.pages.carousel.edit.url": "跳转链接",
    "admin.pages.carousel.edit.image": "轮播图",
    "admin.pages.carousel.edit.image.tip": "建议尺寸：750*300",
    "admin.pages.carousel.edit.image.tip.2": "建议尺寸：750*300",
    "admin.pages.article.target.list": "科普资源受众群体",
    "admin.pages.article.target.edit": "编辑受众群体分类",
    "admin.pages.school.category.list.title": "学校类型管理",
    "admin.pages.school.category.edit.title": "编辑学校类型",
    "admin.pages.school.list.title": "学校信息管理",
    "admin.pages.school.edit.title": "编辑学校信息",
    "admin.pages.science.venue.list.title": "科普场馆列表",
    "admin.pages.science.venue.edit.title": "编辑科普场馆信息",
    "admin.pages.science.venue.route.list.title": "科普研学路线",
    "admin.pages.science.venue.route.edit.title": "编辑科普研学路线信息",
    "admin.pages.config.list.title": "配置参数列表",
    "admin.pages.config.edit.title": "编辑配置参数",
    "admin.pages.volunteer.list.title": "项目列表",
    "admin.pages.volunteer.edit.title": "编辑志愿者信息",
    "admin.pages.volunteer.application.list.title": "志愿者申请列表"
};
